export const blockIconsContentReply = (
	<span className='material-symbols-outlined'>reply</span>
);
